module.exports = __webpack_public_path__ + "img/gaoxin.89f72992.jpg";